import React, { useEffect } from "react";
import { useRouteMatch, Redirect, Route, Switch } from "react-router-dom";

import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import { useDispatch } from "services/redux/rootReducer";
import getAllArticles from "../actions/update/get.getAllArticles";
import ArticleEditorPage from "../screens/article";
import { ArticleType } from "../types/article";
import getAllTags from "features/tagEdit/actions/set/update/get.getAllTags";

const ArticleRouter: React.FC = () => {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();

    const defaultDisplay = () => {
        return <Redirect to={`${path}/news`} />;
    };

    useEffect(() => {
        let unsubscribers: Array<() => void> = [];

        unsubscribers.push(dispatch(getAllArticles()));
        unsubscribers.push(dispatch(getAllTags()));

        return () => {
            unsubscribers.forEach((unsubscriberFn) => unsubscriberFn());
        };
    }, [dispatch]);

    return withAdminNavbar(
        <Switch>
            <Route exact path={path}>
                {defaultDisplay}
            </Route>
            <Route exact path={`${path}/news`}>
                <ArticleEditorPage articleType={ArticleType.News} />
            </Route>
            <Route exact path={`${path}/article`}>
                <ArticleEditorPage articleType={ArticleType.Article} />
            </Route>
            <Route exact path={`${path}/supplier`}>
                <ArticleEditorPage articleType={ArticleType.Supplier} />
            </Route>
        </Switch>
    );
};

export default ArticleRouter;
